<mat-toolbar class="header" crole="heading">
  <span>
    <button mat-icon-button (click)="toggleSideNav()" type="button">
      <mat-icon aria-hidden="false" aria-label="menu icon">menu</mat-icon>
    </button>
  </span>
  <a [routerLink]="['/']"><img src="./assets/logo-dedalus-02-1.svg" height="40px" class="ml-3"></a>

  <button *ngIf="isAllowed('ROLE_CONFIGURATION')" [matMenuTriggerFor]="configurationMenu" mat-button (click)="getConfigurationGroupProperties()">
    <mat-icon class="example-icon" aria-hidden="false" aria-label="Example delete icon">settings</mat-icon>
    <mat-menu #configurationMenu="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="groupsMenu">Grupos</button>
      <button *ngIf="configurationGroupProperty?.users" mat-menu-item [routerLink]="['configuration/users']">Usuarios</button>
      <button *ngIf="configurationGroupProperty?.alerts" mat-menu-item [routerLink]="['configuration/alerts']">Alertas</button>
    </mat-menu>
  </button>

  <mat-menu #groupsMenu="matMenu">
    <button mat-menu-item *ngIf="configurationGroupProperty?.groupReport" [routerLink]="['configuration/groups/reports']">Informes</button>
    <button mat-menu-item *ngIf="configurationGroupProperty?.groupOrderEntry" [routerLink]="['configuration/groups/order-entry']">Ingreso</button>
    <button mat-menu-item *ngIf="configurationGroupProperty?.groupPhlebotomy" [routerLink]="['configuration/groups/phlebotomy']">Extracción</button>
    <button mat-menu-item *ngIf="configurationGroupProperty?.groupAlert" [routerLink]="['configuration/groups/alerts']">Alertas</button>
  </mat-menu>

  <span class="spacer"> </span>
  <span class="nav-icons">
    <button *ngIf="showGroupList()" [disabled]="canChange" mat-button (click)="openMenu()"
      [matMenuTriggerFor]="groupsSelector">
      {{group.description + " &nbsp;"}} <mat-icon aria-hidden="false" aria-label="Change group">groups</mat-icon>
    </button>
    <mat-menu #groupsSelector="matMenu">
      <mat-selection-list [multiple]="false" *ngIf="groups != undefined && showGroupList()">
        <mat-list-option *ngFor="let item of groups" (click)="selectGroup(item)" [selected]="group.id == item.id">
          {{item.description}}
        </mat-list-option>
      </mat-selection-list>
    </mat-menu>
  </span>
  <mat-menu #config="matMenu">
    <button mat-menu-item [routerLink]="['configuration/groups']">Grupos</button>
    <button mat-menu-item [routerLink]="['configuration/users']">Usuarios</button>
    <button mat-menu-item [routerLink]="['configuration/alarms']">Alarmas</button>
  </mat-menu>
  <span class="nav-icons">
    <button mat-button [matMenuTriggerFor]="userMenu">
      {{ user?.username}} <mat-icon class="example-icon" aria-hidden="false" aria-label="Example delete icon">person
      </mat-icon>
    </button>
  </span>
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="logout()">
      <mat-icon class="example-icon" aria-hidden="false" aria-label="Example delete icon">logout</mat-icon> Cerrar
      sesión
    </button>
  </mat-menu>

</mat-toolbar>